import React from 'react';
import styles from './hero.module.scss';


class Hero extends React.Component {

  render () {
    return (
      <div className={styles.hero} style={{backgroundImage: `url('${this.props.image}')`}}>
        <div className={styles.wrapper}>
          <div className={styles.content}>
            {this.props.children}        
          </div>
        </div>
      </div>
    )
  }
}

export default Hero;


// WEBPACK FOOTER //
// ./src/components/Hero/index.js